<template>
  <div class="container mt-4">
    <HMStudioBackButton />
    <div class="row">
      <div class="col h1 mb-md-4 mt-2">
        {{ $t('STUDIO.TITLE.REDEMPTIONS') }}
      </div>
    </div>
    <StudentClassCard />
  </div>
</template>

<script>
import Vue from 'vue';
import StudentClassCard from '@/web/components/shop/StudentClassCard';

export default Vue.extend({
  name: 'StudentRedemptions',
  components: {
    StudentClassCard,
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
